import mailErrorService from '@/services/mailError.service.js'

export default {

  getMailErrors ({commit, dispatch}, data){
    return mailErrorService.getMailErrors(data)
      .then(response =>{
        if (response.success && response.data){
            const listMailErrorData = response.data.data
            commit('SET_LIST_MAIL_ERRORS', listMailErrorData)
            commit('SET_INFO_DB', {totalPage: response.data.last_page, totalRow: response.data.total})
            return Promise.resolve(response.data)
        } else {
            commit('SET_LIST_MAIL_ERRORS', [])
            dispatch("alertError",response.message, {root: true});
            return Promise.reject(response.message)
        }
      })
      .catch(error =>{
        commit('SET_LIST_MAIL_ERRORS',[])
        return Promise.reject(false)
      })
  },

 
}